import React from 'react'
import PropTypes from 'prop-types'
import { formatPrice } from 'common/helpers'

import CircleLoader from 'components/loaders/CircleLoader/CircleLoader'


const Price = ({ children, className, id, value, loading, isCents, withCents, dataTestId }) => {
  if (loading) {
    return (
      <CircleLoader />
    )
  }

  return (
    <span className={className} id={id} data-testid={dataTestId}>
      {formatPrice(
        children || value,
        isCents,
        true,
        withCents ? 2 : 0
      )}
    </span>
  )
}

Price.propTypes = {
  children: PropTypes.any,
  value: PropTypes.any,
  loading: PropTypes.bool,
  isCents: PropTypes.bool,
  withCents: PropTypes.bool,
  dataTestId: PropTypes.string,
}

Price.defaultProps = {
  loading: false,
  isCents: false,
  withCents: true,
}


export default Price
